/**
 * Name of the default outlet outlet.
 * @type {string}
 */
export const DEFAULT_OUTLET_NAME = "__DEFAULT";
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
